import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';
import React from 'react';
import type { SiteProfile } from '../siteProfiles/types';
import { PROFILES, PROFILE_LIST, wognumProfile } from '../siteProfiles';

interface SiteProfileContextValue {
  profile: SiteProfile;
  setProfileById: (id: string) => void;
  profiles: SiteProfile[];
}

const SiteProfileContext = createContext<SiteProfileContextValue | null>(null);

const STORAGE_KEY = 'hub_active_site_profile';

export function SiteProfileProvider({ children }: { children: ReactNode }) {
  const [profile, setProfile] = useState<SiteProfile>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return (stored && PROFILES[stored]) || wognumProfile;
  });

  const setProfileById = useCallback((id: string) => {
    const p = PROFILES[id];
    if (p) {
      setProfile(p);
      localStorage.setItem(STORAGE_KEY, id);
    }
  }, []);

  return React.createElement(
    SiteProfileContext.Provider,
    { value: { profile, setProfileById, profiles: PROFILE_LIST } },
    children
  );
}

export function useSiteProfile(): SiteProfileContextValue {
  const ctx = useContext(SiteProfileContext);
  if (!ctx) throw new Error('useSiteProfile must be used within SiteProfileProvider');
  return ctx;
}
